import { IChainType } from '../../../state/type';
import { IWeb3ChainType, IWeb3NetworkType } from '../type';

const chain: IChainType | undefined = undefined;
const networkType: IWeb3NetworkType = 'main';

const chainInfo: IWeb3ChainType = {
  chain: chain,
  type: 'TON',
  name: 'Toncoin',
  icon: undefined,
  networkType,
};

export default chainInfo;
